import axios from './requestInterceptor'
import {
  ICreateOtpData,
  IListBankDetailsData,
  IBankDetailData,
  ISuccessCallback,
  IErrorCallback,
  IRequestToken,
  IIdentityAttribute,
  IMessagesData
} from './types'
import queryString from 'query-string'

export async function createOTP(
  data: ICreateOtpData,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post('/otp', data)
    .then((response) => {
      successCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function getTokenRequest(
  data: IRequestToken,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post('/otp-token', data, { withCredentials: true })
    .then((response) => {
      successCallback(response.data.data.token)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function changeIdentityAttribute(
  userId: string,
  data: IIdentityAttribute,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post(`/users/${userId}/identity-attributes/`, data)
    .then((response) => {
      successCallback(response)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function getListBankDetailsRequest(
  userId: string | undefined,
  data: IListBankDetailsData,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/bank-details/`, {
      params: data
      // paramsSerializer: function (params) {
      //   return queryString.stringify(params)
      // }
    })
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function createBankDetailRequest(
  userId: string | undefined,
  data: IBankDetailData,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post(`/users/${userId}/bank-details/`, data)
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}
export interface GetNotificationResponse {
  unique_id: string
  title: string
  sender_user: null
  text: string
  category: Category
  priority: Priority
  sent_at: Date
  created_at: Date
  read_at: Date | null
}

export enum Category {
  Operation = 'OPERATION'
}

export enum Priority {
  Medium = 'MEDIUM'
}

export async function getNotificationsRequest(
  userId: string | undefined,
  data: IMessagesData,
  successCallback: ISuccessCallback<GetNotificationResponse[]>,
  errorCallback: IErrorCallback,
  abortSignal?: AbortSignal
) {
  await axios
    .get(`/users/${userId}/notifications/`, {
      params: data,
      paramsSerializer: function (params) {
        return queryString.stringify(params)
      },
      signal: abortSignal
    })
    .then((response) => {
      successCallback(response.data.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function setReadMessagesRequest(
  userId: string | undefined,
  data: { notifications_unique_id: string[] },
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .post(`/users/${userId}/notifications/read/`, data)
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function updateUserRequest(
  userId: string | undefined,
  data: any,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .put(`/users/${userId}/`, data)
    .then((response) => {
      successCallback(response.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}

export async function retrieveUserRequest(
  userId: string | undefined,
  successCallback: ISuccessCallback,
  errorCallback: IErrorCallback
) {
  await axios
    .get(`/users/${userId}/`)
    .then((response) => {
      successCallback(response.data.data)
    })
    .catch((error) => {
      errorCallback(error)
    })
}
